import React, { useEffect, useContext, useState } from "react";
import "../../css/ManagePlan.css";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import config from "../../config/config"; // Make sure this path is correct
import PropertyListing from "./PropertyListing";
import ConfirmationModal from "../modals/ConfirmationModal";

const MyListings = () => {
  const { user } = useContext(AppContext);
  const [listingData, setListingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const token = config.getAuthToken();

  const fetchListingData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/getMyListings`,
        { user_id: user?.data?.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        setListingData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching listings:", error);
      setShowModal(true);
      setMsgTitle("Failed to fetch listings. Please try again.");
      setMessage("");
    }
    setIsLoading(false);
  };

  const handleDelete = (id) => {
    setListingData((prevData) =>
      prevData.filter((item) => item.property_id !== id)
    );
  };

  useEffect(() => {
    fetchListingData();
  }, [user?.data?.id]);

  return (
    <>
      <div>
        <div className="nofltrbx">
          <div className="title-header breadcrumb">
            <div className="profile-path">
              <span>My Listed Properties</span>
            </div>
          </div>
        </div>

        <div className="manage-main-area12">
          <div className="d-flex flex-column" style={{ width: "100%" }}>
            {isLoading ? (
              <p className="text-center">Loading List...</p>
            ) : listingData && listingData.length > 0 ? (
              listingData.map((listing, index) => (
                <PropertyListing
                  project={listing}
                  handleDelete={handleDelete}
                />
              ))
            ) : (
              <p>No listings found.</p>
            )}
          </div>
        </div>
        {showModal && (
          <ConfirmationModal
            onClose={() => setShowModal(false)}
            title={msgTitle}
            message={message}
            icon="fa fa-times-circle-o"
            theme="red"
          />
        )}
      </div>
    </>
  );
};

export default MyListings;
